module.exports = __webpack_public_path__ + "static/6013-San-Bernard-Front-1024x443-671ecf9456480652963a77c6ec031b7e.jpg";